export default __webpack_public_path__ + "static/media/Icon-Arrow_Loss.abcf9cee.svg";